import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { formatDate } from "../../helper/Helper";
import Breadcrump from "../../components/Breadcrump";
import blogAPI from "../../api/BlogApi";
import SEO from "../../components/SEO";
import { useSiteConfig } from "../../context/SiteConfigContext";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
} from "react-icons/fa";
import RelatedCard from "./relatedCard";

function DetailPage() {
  const { slug } = useParams();
  const [item, setItem] = useState({});
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [metaData, setMetaData] = useState({});
  const { config } = useSiteConfig();

  const fetchBlogsDetail = async () => {
    try {
      const params = { limit: 4 };
      const res = await blogAPI.details(slug, params);

      if (res.code === 200) {
        const { blog, relatedBlogs } = res.data;
        setItem(blog);
        setRelatedBlogs(relatedBlogs);
        setMetaData(blog?.meta);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    }
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0].substring(0, 2).toUpperCase();
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  };

  useEffect(() => {
    fetchBlogsDetail();
  }, [slug]);

  return (
    <>
      <Breadcrump title={item?.title} />
      <SEO meta={metaData} />

      <div className="blog-detail-page">
        {/* ── HERO ─────────────────────────────────────────────── */}
        <section className="container">
          <div className="row">
            {/* LEFT SIDE - CONTENT */}
            <div className="blog-hero-content col-md-7 pt-5 order-2 order-md-1 ">
              
              <h1 className="blog-detail-title">{item?.title}</h1>
              <p className="blog-detail-subtitle">{item?.shortDescription}</p>

              <div className="blog-detail-author">
                <div className="blog-detail-avatar">
                  {getInitials(item?.author)}
                </div>
                <div>
                  <p className="blog-detail-author-name">{item?.author}</p>
                  <p className="blog-detail-author-date">
                    {formatDate(item?.date)}
                  </p>
                </div>
              </div>
               <div className="blog-detail-layout">
            {/* Social Sidebar */}
            <aside className="blog-detail-sidebar">
              <span className="blog-detail-sidebar-label">Connect</span>
              <div className="blog-detail-sidebar-line" />
              <div className="blog-detail-socials">
                {config?.socialMedia?.facebook && (
                  <a
                    href={config.socialMedia.facebook}
                    target="_blank"
                    rel="noreferrer"
                    className="blog-social-icon"
                  >
                    <FaFacebook size={15} />
                  </a>
                )}
                {config?.socialMedia?.instagram && (
                  <a
                    href={config.socialMedia.instagram}
                    target="_blank"
                    rel="noreferrer"
                    className="blog-social-icon"
                  >
                    <FaInstagram size={15} />
                  </a>
                )}
                {config?.socialMedia?.twitter && (
                  <a
                    href={config.socialMedia.twitter}
                    target="_blank"
                    rel="noreferrer"
                    className="blog-social-icon"
                  >
                    <FaTwitter size={15} />
                  </a>
                )}
                {config?.socialMedia?.youtube && (
                  <a
                    href={config.socialMedia.youtube}
                    target="_blank"
                    rel="noreferrer"
                    className="blog-social-icon"
                  >
                    <FaYoutube size={15} />
                  </a>
                )}
                {config?.socialMedia?.linkedin && (
                  <a
                    href={config.socialMedia.linkedin}
                    target="_blank"
                    rel="noreferrer"
                    className="blog-social-icon"
                  >
                    <FaLinkedin size={15} />
                  </a>
                )}
              </div>
            </aside>

            {/* Article Body */}
            <article className="blog-detail-article">
              <div
                className="blog-detail-content"
                dangerouslySetInnerHTML={{ __html: item?.description }}
              />

              {/* Related Blogs */}
              {relatedBlogs && relatedBlogs.length > 0 && (
                <div className="blog-detail-related">
                  <div className="blog-detail-related-header">
                    <span className="blog-detail-related-eyebrow">
                      More Stories
                    </span>
                    <h3 className="blog-detail-related-heading">
                      Related Reads
                    </h3>
                    <div className="blog-detail-related-rule" />
                  </div>

                  <div className="blog-detail-related-list">
                    {relatedBlogs.map((blog, index) => (
                      <RelatedCard key={blog._id || index} item={blog} />
                    ))}
                  </div>
                </div>
              )}

              <div className="blog-detail-view-all">
                <Link to="/blog" className="blog-detail-view-all-link">
                  View All Stories
                  <svg
                    viewBox="0 0 13 13"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    width="13"
                    height="13"
                  >
                    <path
                      d="M1 6.5h11M7 1l5.5 5.5L7 12"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Link>
              </div>
            </article>
          </div>
            </div>
            

            {/* RIGHT SIDE - IMAGE */}
            <div className="blog-hero-img-wrap col-md-5 order-1 order-md-2">
              <img
                src={item?.image}
                alt={item?.title}
                className="blog-hero-img w-100"
              />
            </div>
          </div>
        </section>
        {/* ── BODY ─────────────────────────────────────────────── */}
       
      </div>
    </>
  );
}

export default DetailPage;
